//Aqui se defiene las variables para el control y manejo de los input
export const optionClient = [
    { id: 0, name: 'Hogar' },
    { id: 1, name: 'Empresa' },
]

export const initialForm = {
    selectDoc: '',
    typeDoc: '',
    password: '',
}


export const optionDoc = [
    { id: 0, name: 'RIF' },
    { id: 1, name: 'CI' },
]

export const optionCorporativo = [
    { id: 0, name: 'Pago' },
    { id: 1, name: 'Retención' },
]

export const optionRetencion = [
  { id: 0, name: 'Sí' },
  { id: 1, name: 'No' },
]

export const optionPhoneCorporativo = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "0414" },
    { id: 3, name: "0424" },
    { id: 4, name: "0412" },
    { id: 5, name: "0426" },
    { id: 6, name: "0416" },
  ];

  export const optionBancoBs = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "Bancaribe C.A." },
    { id: 3, name: "Banco Mercantil C.A" },
    { id: 4, name: "Banco Provincial S.A." },
    { id: 5, name: "Banesco S.A.C.A." },
    { id: 6, name: "Banco Nacional de Crédito C.A." },
  ];

  export const optionCtaBancaribe = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "01140161921610064198" }
  ];
  export const optionCtaMercantil = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "01050699941699006946" },
    { id: 3, name: "01050699971699028273" },
  ];
  export const optionCtaProvincial = 
  [{ id: 1, name: "Seleccione" },{ id: 1, name: "01080911830100014354" }];

  export const optionCtaBanesco = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "01341099260001000145" }
  ];
  export const optionCtaBNC = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "01910154192100009136" }
  ];

  export const optionBancoDivisas = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "Bancaribe C.A." },
    { id: 3, name: "Banco Mercantil C.A" },
    { id: 4, name: "Banco Provincial S.A." },
    { id: 5, name: "Banesco S.A.C.A." },
    { id: 6, name: "Mi Banco C.A." },
    { id: 7, name: "Banesco Panamá" },
    { id: 8, name: "Banesco USA" },
    { id: 9, name: "Mercantil Panamá" }
  ];

  export const optionCtaBanescoUSA = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "1500110927" }
  ];

  export const optionCtaBanescoPanama = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "110000099232" }
  ];

  export const optionCtaMercantilPanama = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "30023812" }
  ];

  export const optionCtaBancaribeUSD = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "01140165191654018860" }
  ];

  export const optionCtaMercantilUSD = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "01050699905699042326" }
  ];
  export const optionCtaProvincialUSD = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "01080948000100059457" }
  ];
  export const optionCtaBanescoUSD = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "01341740780021496430" }
  ];
  export const optionCtaMiBancoUSD = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "01690001079000000908" }
  ];


  export const optionCtaMoneda = [
    { id: 1, name: "Seleccione" },
    { id: 2, name: "Bolívares" },
    { id: 3, name: "Dólares" }
  ];

  export const optionDefault = [
    { id: 1, name: "Seleccione una cuenta" }

  ];
  export const optionDefaultBanco = [
    { id: 1, name: "Seleccione un banco" }

  ];
  export const formNotificacionesCorpo = {
    selectNumber: "",
    phone: "",
    email: "",
    cuentasSelect: "",
    factura: "",
    notificacion:"",
    bancoReceptor: "",
    cuentaReceptor: "",
    date: "",
    monto: "",
    montoCompMunicipal: "",
    montoISLR: "",
    montoIVA: "",
    montoTimbreFiscal: "",
    numberReference: "",
    tipoMoneda: "",
    tipoNotificacion: "",
    isRetencion: "",
    fileIVA: "",
    fileISLR: "",
    fileTF:"",
    fileMunicipal:"",
    

  };
